const RAG_STYLES = {
  green: "bg-emerald-50 text-emerald-700 border-emerald-200",
  amber: "bg-amber-50 text-amber-700 border-amber-200",
  red: "bg-red-50 text-red-700 border-red-200",
};

const RAG_DOT = { green: "bg-rag-green", amber: "bg-rag-amber", red: "bg-rag-red" };

export function RagBadge({ status, testid }) {
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold uppercase tracking-wide ${RAG_STYLES[status] || RAG_STYLES.red}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${RAG_DOT[status] || RAG_DOT.red}`} />
      {status}
    </span>
  );
}

const DOC_STYLES = {
  approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  pending: "bg-amber-50 text-amber-700 border-amber-200",
  rejected: "bg-red-50 text-red-700 border-red-200",
  replacement_requested: "bg-orange-50 text-orange-700 border-orange-200",
  missing: "bg-slate-100 text-slate-500 border-slate-200",
};

const DOC_LABELS = {
  approved: "Approved",
  pending: "Pending Review",
  rejected: "Rejected",
  replacement_requested: "Replacement Requested",
  missing: "Missing",
};

export function DocStatusBadge({ status, testid }) {
  return (
    <span data-testid={testid} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${DOC_STYLES[status] || DOC_STYLES.missing}`}>
      {DOC_LABELS[status] || "Missing"}
    </span>
  );
}
